import Ajax from 'js/utils/ajax/ajax';

export const getFuturePriceAdjustments = () => Ajax.get('/invoices/v1/futurepriceadjustments');

export const addFuturePriceAdjustment = (priceAdjustment) =>
  Ajax.post('/invoices/v1/futurepriceadjustments', priceAdjustment);
